import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { FC, useState } from 'react';
import { ILocationSubscription } from '../../model';

import styles from './LocationDetails.module.scss';

interface Props {
  subscription: ILocationSubscription;
  onClose: () => void;
  onSave: (capacity: number) => Promise<void>;
}

const EditSubscriptionCapacityDialog: FC<Props> = ({ subscription, onClose, onSave }) => {
  const [capacity, setCapacity] = useState<number | null>(subscription.capacity ?? null);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (capacity == null) return;
    setIsSaving(true);
    try {
      await onSave(capacity);
    } catch {
      // the error is already surfaced via the global API error handler toast
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog title='Edit Subscription' onClose={onClose}>
      <div className={styles.editField}>
        <span className={styles.editFieldLabel}>Subscription ID</span>
        <span>{subscription.subscriptionId}</span>
      </div>
      {subscription.subscriptionName && (
        <div className={styles.editField}>
          <span className={styles.editFieldLabel}>Subscription Name</span>
          <span>{subscription.subscriptionName}</span>
        </div>
      )}
      <div className={styles.editField}>
        <label className={styles.editFieldLabel} htmlFor='subscription-capacity'>
          Capacity
        </label>
        <NumericTextBox
          id='subscription-capacity'
          value={capacity}
          onChange={(e) => setCapacity(e.value)}
          min={0}
          format='n0'
          width='100%'
        />
      </div>

      <DialogActionsBar>
        <Button themeColor='primary' disabled={capacity == null || isSaving} onClick={handleSave}>
          Save
        </Button>
        <Button onClick={onClose} disabled={isSaving}>
          Cancel
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default EditSubscriptionCapacityDialog;
